import React from "react";
import Modal from "../Modal";
import images from "../../../../utilities/images/images";
import "./ResumeModal.css";

const ResumeModal = ({ isOpen, onClose, onSubmit, onResume }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="38rem"
      height="22rem"
    >
      <div className="resume-wrapper">

        <div className="resume-icon">
          <img src={images.resume_practice_icon} alt="resume" />
        </div>

        <h2 className="resume-title">Resume Practice</h2>

        <p className="resume-subtitle">
          Are you sure you want to Resume?
        </p>

        <div className="resume-buttons">

          <button
            className="resume-submit-btn"
            onClick={onSubmit}
          >
            Submit
          </button>

          <button
            className="resume-confirm-btn"
            onClick={onResume}
          >
            Resume Practice
          </button>

        </div>
      </div>
    </Modal>
  );
};

export default ResumeModal;